// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"733":"d229b3e8","740":"3a25b4e3","853":"5a074b93"}[chunkId] + ".chunk.css";
};